import React from "react";
import { Form, Input, Switch } from "antd";
import { getMercadoPago, upsertMercadoPago } from "./api";
import { MercadoPagoConfig } from "./types";
import {
  CampoMontoMaximo,
  CamposComunes,
  GatewayPanel,
  GatewayPanelProps,
} from "./GatewayPanel";
import { Subtitulo } from "./ui";

export const MercadoPagoPanel: React.FC<GatewayPanelProps> = ({
  sellerCode,
  ...panel
}) => (
  <GatewayPanel<MercadoPagoConfig>
    {...panel}
    title="Mercado Pago"
    load={() => getMercadoPago(sellerCode)}
    save={(values) => upsertMercadoPago(sellerCode, values)}
    savedMessage="Mercado Pago guardado"
  >
    <CamposComunes />
    <Form.Item
      label="Cobrar dentro del sitio"
      extra="Si está apagado, el cliente paga en la página de Mercado Pago."
      name="useCheckoutApi"
      valuePropName="checked"
    >
      <Switch />
    </Form.Item>

    <Subtitulo>Credenciales</Subtitulo>
    <Form.Item label="Clave pública" name="publicKey">
      <Input />
    </Form.Item>
    <Form.Item label="Token de acceso" name="accessToken">
      <Input.Password placeholder="••••••••" />
    </Form.Item>
    <CampoMontoMaximo />
  </GatewayPanel>
);
